import TTMPropertyLogChartForm from "./TTMPropertyLogChartForm.vue";
export default TTMPropertyLogChartForm;